module.exports = __webpack_public_path__ + "img/menu.e8e6a41e.svg";